import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useDiscordIntegrationQuery = createQueryHook(
  MembershipsCreatorApiClient.getDiscordIntegration,
  {
    queryKey: ['discordIntegration'],
  },
)
